<template>
  <v-layout justify-center>
    <v-flex>

      <v-container fluid class="ma-0 py-0">
        <v-layout row wrap>
          <v-flex style="text-align: right;">
            
            <v-btn fab small color="primary" icon @click="btn_copyURL()">
              <v-icon>link</v-icon>
            </v-btn>
            <v-btn fab small color="primary" icon :href="src.url" download v-if="src.type == 'img'">
              <v-icon>download</v-icon>
            </v-btn>
            <v-btn fab small color="primary" icon @click="btn_share()">
              <v-icon>share</v-icon>
            </v-btn>
            
          </v-flex>
        </v-layout>
        
        <v-layout>
          <v-flex>
            <v-img v-if="src.type == 'img'"
              :src="src.url"
              :height="src.height"
              contain
            >
            </v-img>

            <video v-else-if="src.type == 'vid'"
              width="100%"
              :height="src.height"
              controls
            >
              <source :src="src.url" :type="src.ext">
            </video>

            <iframe v-else
              id="frm_window"
              frameborder="0"
              :src="src.url"
              width="100%"
              :height="src.height"
              scrolling="no"
            ></iframe>

          </v-flex>
        </v-layout>

      </v-container>
      
    </v-flex>
  </v-layout>
</template>

<script>
import auth from "../../functions/auth";
import common from "../../functions/general";
// import comm from "../../functions/communication.api";

export default {
  name: "Media",
  // components: {
  //   Breadcrumbs: Breadcrumbs
  // },
  data: () => ({
    // iframe: {
    //   // visible: false,
    //   url: "",
		// 	height: "1200px",
    // },
    URL: "",
    src: {
      url: "",
      ext: "",
      type: "",
      height: "12000px",
      fullURL: "",
    }
  }),
  mounted: function() {
    // this.initial();
    var menu = auth.getMenu().concat(auth.getMenu_int());
    // var pageID = common.App.get_pageID();
        
    // var card = menu.filter(function(AppMenu) {
    //   return AppMenu.id == pageID;
    // });

    var pageUUID = common.App.get_pageUUID();
        
    var card = menu.filter(function(AppMenu) {
      return AppMenu.uuid == pageUUID;
    });

		this.src.url = card[0].component_path.iframe_path;
    
    if (card[0].component_path.iframe_height) {
      this.src.height = card[0].component_path.iframe_height;
    }

    // if (this.src.url.match("http")) {
    //   this.src.fullURL = this.src.url;
    // } else {
    //   this.src.fullURL = location.origin + "/" + this.src.url;
    // }
    
    this.src.fullURL = common.App.get_share_link(this.src.url);

    this.src.type = card[0].component_path.media_type;
    
    if (this.src.type == "vid") {
       var ext = this.src.url.substring(this.src.url.lastIndexOf('.') + 1, this.src.url.length);
       this.src.ext = "video/" + ext;
    }
  },
  methods: {    
    async btn_copyURL() {
      try {
        await navigator.clipboard.writeText(this.src.fullURL);
        common.wMsgBox.Success("Sucessfully copy link!");
      } catch (err) {
        common.wMsgBox.Error("Failed to copy link!");
      }
    },
    async btn_share() {
      const shareData = {
        title: "mySuite File Sharing",
        text: "You may download the file here:-",
        url: this.src.fullURL,
      };

      try {
        await navigator.share(shareData);
        // common.wMsgBox.Success("Sucessfully shared.");
      } catch (err) {
        common.wMsgBox.Error("Failed to share!");
      }
    }
  }
};
</script>

<style>
</style>